export default __webpack_public_path__ + "static/media/catered-drinks.beafd529.svg";